module.exports = __webpack_public_path__ + "img/time.d0dd3b4b.png";